<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "AreaIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
